import React from 'react';
import { Link } from 'react-router-dom';
import './CTA.css';

const CTA = () => {
  return (
    <section className="cta" id="contact">
      <div className="cta-container">
        <div className="cta-content">
          <h2 className="cta-title">Ready to Get Started?</h2>
          <p className="cta-description">
            Speak with our experts to learn how we can help your business achieve its technology goals.
          </p>
          <Link to="/contact" className="btn-cta">Speak to an Expert</Link>
        </div>
      </div>
    </section>
  );
};

export default CTA;
